import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class SessionService {

  constructor(
    private http: HttpClient
  ) { }

    set(key: string, value: any) {
      sessionStorage.setItem(key, JSON.stringify(value));
    }

    get(key: string) {
      const data = sessionStorage.getItem(key);
      if (data) {
        return JSON.parse(data);
      } else {
        return;
      }
    }

    remove(key: string) {
      sessionStorage.removeItem(key);
    }

    update(key: string, value: any) {
      const data = this.get(key);
      if (data) {
        for (const i in data) {
            if (data[i]['id'] === value['id']) {
              data[i] = value;
              this.set(key, data);
              return;
            }
        }
    }
  }

  clear() {
    sessionStorage.clear();
  }

}
